import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TaxRateConfig, TaxRateConfigCreate, TaxRateConfigFilter } from '../data/taxRateConfig';

export function createTaxRateConfigService(client: AxiosInstance) {
  return createCrudService<TaxRateConfig, TaxRateConfigCreate, TaxRateConfigFilter>(
    client,
    '/accounting/TaxRateConfig',
    'id',
  );
}

export type TaxRateConfigService = CrudService<TaxRateConfig, TaxRateConfigCreate, TaxRateConfigFilter>;
